<div class="resultdiv">
  <button *ngIf="!mobiledevice && !viewAddSign && !edit && can_edit_member_signs" class="btn btn-border" style="margin-bottom: 10px;" (click)="addSign()" title="Lägg till">Lägg till</button>
  <table *ngIf="!viewAddSign && !edit" class="table table-bordered">
    <thead role="rowgroup">
      <tr>
        <th>Utmärkelse</th>
        <th>Institution</th>
        <th>Datum</th>
        <th></th>
      </tr>
    </thead>
    <tr *ngFor="let ms of membersigns">
      <td>{{ms.signName}}</td>
      <td>
        <a [routerLink]="['/institutions/id/', ms.institutionId]">{{ms.institutionShortName}}: {{ms.institutionName}}</a>
      </td>
      <td>{{ms.date | date: 'yyyy-MM-dd'}}</td>
      <td style="text-align: center;">
        <span *ngIf="ms.currentUserCanEdit && !mobiledevice" (click)="editSign(ms)" title="Ändra" style="font-size:11px;color:rgb(20, 144, 185);">Ändra</span>
        <i *ngIf="ms.currentUserCanEdit && !mobiledevice" (click)="confirmRemoveSign(ms)" style="margin-left:25px;color: #920000;font-weight:bold;" class="fa fa-trash" title="Ta bort" aria-hidden="true"></i>
      </td>
    </tr>
  </table>
</div>
<p-dialog header="{{editmembersign?.institutionShortName}} {{editmembersign?.institutionName}} [{{editmembersign?.signName}}]" [(visible)]="edit" [modal]="true" [style]="{width: '500px'}" [baseZIndex]="10000" appendTo="body" [draggable]="true" [resizable]="false">
  <div *ngIf="edit">
    <p-fieldset legend="Ändra utmärkelse">
      <form [formGroup]="editform">
        <div class="row">
          <div *ngIf="roleid===12 || roleid===13" class="form-group col-md-8">
            <label for="institutionId">Institution</label>
            <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" required>
              <option></option>
              <option *ngFor="let m of memberships" [ngValue]="m.institution.id">{{m.institution.shortName}} - {{m.institution.name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Datum:</label>
            <input type="text" class="form-control form-control-sm" style="max-width:100px;" formControlName="date" mask="0000-00-00">
          </div>
        </div>
        <br>
        <span>
          <button class="btn border" (click)="saveSign(editform.value)">Spara</button>
          <button class="btn border" style="margin-left:20px;" (click)="cancelSign()">Avbryt</button>
        </span>
      </form>
    </p-fieldset>
  </div>
</p-dialog>